import api from "../api/axiosConfig";

const customersService = {
  getCustomers: () => api.get("/customers"),
  createCustomer: (data) => api.post("/customers", data),
  deleteCustomer: (id) => api.delete(`/customers/${id}`),
  registerVisit: (id) => api.post(`/customers/${id}/visits`),
  removeVisit: (id) => api.delete(`/customers/${id}/visits`),
  getPublicCustomer: (slug) => api.get(`/public/customers/${slug}`),
};

export default customersService;
